// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidenav {
  width: 230px;
  position: fixed;
  z-index: 1;
  top: 110px;
  left: 150px;
  background: white;
  overflow-x: hidden;
  padding: 8px 0;
}

.sidenav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 25px;
  color: #2196F3;
  display: block;
}

.sidenav a:hover {
  color: #064579;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
`, "",{"version":3,"sources":["webpack://./src/app/all-sidebar/all-sidebar.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU,iBAAiB,CAAC;EAC5B,YAAY,eAAe,CAAC;AAC9B","sourcesContent":[".sidenav {\n  width: 230px;\n  position: fixed;\n  z-index: 1;\n  top: 110px;\n  left: 150px;\n  background: white;\n  overflow-x: hidden;\n  padding: 8px 0;\n}\n\n.sidenav a {\n  padding: 6px 8px 6px 16px;\n  text-decoration: none;\n  font-size: 25px;\n  color: #2196F3;\n  display: block;\n}\n\n.sidenav a:hover {\n  color: #064579;\n}\n\n@media screen and (max-height: 450px) {\n  .sidenav {padding-top: 15px;}\n  .sidenav a {font-size: 18px;}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
